import { Flex, theme } from '@/components';
import { CascaderFieldTag } from '@/features/search/_components/_common/tags/CascaderFieldTag';
import { TextSearchTag } from '@/features/search/_components/_common/tags/TextSearchTag';
import type { FC } from 'react';
import { KsAnalysisSearchKeys } from '../../_models/ks-analysis-search';
import { KsCommonFilterTag } from './KsCommonFilterTag';
import { KsPaymentTag } from './KsPaymentTag';

export const KsAnalysisSearchSearchFieldTags: FC<{
  onResetPayment: () => void;
}> = ({ onResetPayment }) => {
  const { token } = theme.useToken();
  return (
    <Flex vertical gap={8} wrap="wrap">
      <Flex
        gap={8}
        style={{ background: token.colorBgLayout, padding: 5 }}
        wrap="wrap"
      >
        {KsAnalysisSearchKeys.map((field) => {
          switch (field) {
            case 'q':
              return <TextSearchTag key={field} />;
            case 'corporateNumber':
              return (
                <KsPaymentTag key={field} onResetPayment={onResetPayment} />
              );
            default:
              return <KsCommonFilterTag key={field} field={field} />;
          }
        })}
      </Flex>
      <CascaderFieldTag field="nestedOrganizationIds" />
    </Flex>
  );
};
